import React, { createContext, useContext, useState, useCallback } from 'react';
import AlertModal from '../components/ui/AlertModal/AlertModal';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [queue, setQueue] = useState([]);

  // showAlert returns a Promise that resolves when OK is pressed
  const showAlert = useCallback((message, title = '') => {
    return new Promise((resolve) => {
      setQueue((prev) => [...prev, { message, title, resolve, id: Date.now() + Math.random() }]);
    });
  }, []);

  const handleClose = useCallback((id, resolve) => {
    setQueue((prev) => prev.filter((item) => item.id !== id));
    resolve();
  }, []);

  const current = queue[0] || null;

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      {current && (
        <AlertModal
          key={current.id}
          title={current.title}
          message={current.message}
          onClose={() => handleClose(current.id, current.resolve)}
        />
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const ctx = useContext(AlertContext);
  if (!ctx) throw new Error('useAlert must be used within AlertProvider');
  return ctx;
};
